import { Theme } from "@mui/material/styles";
import { makeStyles } from "tss-react/mui";
import { HMO } from "constants/hmo";
import { detectHmo } from "utils/hmoDetection";

const isLeumit = detectHmo() === HMO.LEUMIT;

export const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    height: "100%",
  },
  containerCameraActive: {
    position: "fixed",
    inset: 0,
    backgroundColor: "#000",
    zIndex: 1,
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    alignItems: isLeumit ? "stretch" : "center",
    justifyContent: "flex-start",
    overflowY: "auto",
  },
  bodyTitle: {
    margin: `0px 0 ${theme.spacing.spacing5} 0`,
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.size.md,
    ...(isLeumit && {
      textAlign: "start",
      width: "100%",
    }),
  },
  bodyText: {
    padding: `0 ${theme.spacing.spacing7}`,
    fontSize: theme.typography.size.md,
    textAlign: isLeumit ? "start" : "center",
    lineHeight: "23px",
    ...(isLeumit && {
      width: "100%",
      paddingLeft: 0,
      paddingRight: 0,
    }),
  },
  bodyImage: {
    marginTop: 5,
    textAlign: "center",
    // marginLeft: "-48px"
  },
}));
